import { useState } from 'react';
import {
    Button,
    ButtonVariant,
    FootnoteRegular,
    LabelRegular,
    Sheet,
    Spinner,
    XStack,
    YStack,
} from 'smoothie';

import {
    FRUITFUL_FDIC_DISCLOSURE,
    INVESTMENT_PRODUCTS_FDIC_DISCLOSURE,
    ONE_TIME_EXTERNAL_TRANSFER_DISCLOSURE_TEXT,
    STOP_PAYMENT_DISCLOSURE_TEXT,
} from '../../../banking/components/Disclosures';
import { IncomeSplitAgreement } from '../../../banking/components/income-split/IncomeSplitReviewNew';

interface MoneyMapConfirmSheetProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isSaving?: boolean;
}

export const MoneyMapConfirmSheet = ({
    isOpen,
    onClose,
    onConfirm,
    isSaving = false,
}: MoneyMapConfirmSheetProps) => {
    const [hasAccepted, setHasAccepted] = useState(false);

    const handleClose = () => {
        setHasAccepted(false);
        onClose();
    };

    return (
        <Sheet isOpen={isOpen} onClose={handleClose} title="Update Money Map">
            <YStack gap={24}>
                <XStack
                    backgroundColor="$gray200"
                    borderRadius={16}
                    padding={12}
                >
                    <YStack flex={1} gap={8}>
                        <FootnoteRegular fontStyle="italic">
                            {ONE_TIME_EXTERNAL_TRANSFER_DISCLOSURE_TEXT}
                        </FootnoteRegular>
                        <FootnoteRegular fontStyle="italic">
                            {'\n'}
                            {STOP_PAYMENT_DISCLOSURE_TEXT}
                        </FootnoteRegular>
                    </YStack>
                </XStack>

                <IncomeSplitAgreement
                    id="combined-accept"
                    checked={hasAccepted}
                    setChecked={setHasAccepted}
                />

                <YStack gap={12}>
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        text={isSaving ? '' : 'Confirm and update Money Map'}
                        icon={isSaving ? <Spinner /> : null}
                        onPress={onConfirm}
                        disabled={!hasAccepted || isSaving}
                    />
                    <Button
                        variant={ButtonVariant.TERTIARY}
                        text="Cancel"
                        onPress={handleClose}
                        disabled={isSaving}
                    />
                </YStack>

                <YStack gap={4}>
                    <LabelRegular color="$gray1000">
                        {FRUITFUL_FDIC_DISCLOSURE}
                    </LabelRegular>
                    <LabelRegular color="$gray1000">
                        {INVESTMENT_PRODUCTS_FDIC_DISCLOSURE}
                    </LabelRegular>
                </YStack>
            </YStack>
        </Sheet>
    );
};
